import { DatasetTableAction, DatasetTableConfig, dateColumn, TableConfigBuilder, textColumn } from '@ui';

export type NoDataType = '—';
export const noDataRow: NoDataType = '—';

const viewFullDataAction: DatasetTableAction<WorkflowStepRow> = {
    id: 'viewFullData',
    icon: 'ui-icon-input',
    tooltip: 'FLOW_CHART.RUN_LIST_TABLE.VIEW_FULL_DATA',
    tooltipClass: 'sidebar-tooltip',
    showInline: true,
};

export interface WorkflowStepRow {
    stepId: string,
    stateLabel: string,
    nodeType: string,
}

export function createRunStepsTableConfig(
): DatasetTableConfig<WorkflowStepRow> {
    return new TableConfigBuilder<WorkflowStepRow>()
        .columns([
            textColumn<WorkflowStepRow>('stepId', 'FLOW_CHART.RUN_STEPS_TABLE.STEP_ID', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
            textColumn<WorkflowStepRow>('stateLabel', 'FLOW_CHART.RUN_STEPS_TABLE.STATE', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
            textColumn<WorkflowStepRow>('nodeType', 'FLOW_CHART.RUN_STEPS_TABLE.NODE_TYPE', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
        ])
        .actions([
            viewFullDataAction
        ])
        .trackBy('stepId')
        .rowHeight(52)
        .build();
}
